import { ButtonGeneral, MessageBanner, theme, typographyRem } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React, { useContext, useState } from 'react'

import useChatWidget from '../../../hooks/useChatWidget'
import { ProviderContext } from '../../../Provider'
import { GenericOverlay } from '../GenericOverlay/GenericOverlay'
import { ExistingMemberModalStyles } from './ExistingMemberModalStyles'
const { paragraphBody: ParagraphBody, h2: H2, h4: H4 } = typographyRem

interface ExistingMemberModalProps {
  onClose: () => void
}

export const ExistingMemberModal = ({ onClose }: ExistingMemberModalProps) => {
  const { handleCloseModal } = useContext(ProviderContext)
  const { openChatWidget } = useChatWidget()
  const [focused, setFocused] = useState(false)

  const handleExistingMemberModalClose = () => {
    handleCloseModal('existing-member')
    onClose()
  }

  const handleChatClick = () => {
    DataLayer.customEvent({
      eventName: 'contact support',
      section: 'existing member',
      eventType: 'button click',
    })
    openChatWidget()
  }

  return (
    <ExistingMemberModalStyles focused={focused}>
      <GenericOverlay
        onClose={handleExistingMemberModalClose}
        overlay={
          <div>
            <H2 className="heading">Lovely to see you again.</H2>
            <ParagraphBody className="overlay-text text-primary">
              If you’ve insured a car through us before, you’ll need to use a different email this time.
            </ParagraphBody>
            <ParagraphBody className="overlay-text">
              {`Don’t have another email? `}
              <button
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onClick={handleChatClick}
                className="button-link"
              >
                <ParagraphBody className="link button-link-text">Chat to our team</ParagraphBody>
              </button>
              {` and we’ll sort things out for you.`}
            </ParagraphBody>
            <ButtonGeneral
              className="overlay-button"
              label="Change email"
              onClick={() => {
                DataLayer.customEvent({
                  eventName: 'click change email',
                  section: 'existing member',
                  eventType: 'button click',
                })
                handleExistingMemberModalClose()
              }}
            />
            <MessageBanner
              className="tracker-banner"
              text={
                <>
                  <H4>Waiting to renew with us?</H4>
                  <ParagraphBody className="message-text">
                    {`Good news - your quote’s on the way. It’ll land in your inbox 21 days before your current policy
                    ends. `}
                    <a
                      onClick={() => {
                        DataLayer.customEvent({
                          eventName: 'more information',
                          section: 'existing member',
                          eventType: 'button click',
                        })
                      }}
                      className="link link-focused"
                      href="https://help.bymiles.co.uk/hc/en-us/articles/7118573535389-When-will-I-receive-my-renewal-offer"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Click here
                    </a>
                    {` for more information.`}
                  </ParagraphBody>
                </>
              }
              backgroundColor={theme.tints.cyan}
              borderColor={theme.primaryColours.cyan.superDarkCyan}
            />
          </div>
        }
      />
    </ExistingMemberModalStyles>
  )
}
